import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import Videojs from "../video-js";
import Image from "../../elements/image";
import { RichText, Link } from "@sitecore-jss/sitecore-jss-react";
import { PrimaryButton } from "../../elements";
import ImageOverlayImage from './ImageOverlayImage'
import gsap from 'gsap';
import { gtag } from "../../utils";
import { mobileIs, loadScrollMagic, getOverallSettingsClasses } from "../../utils/siteUtils";
import "./style.scss";
const ImageOverlay =  ({ page, rendering, fields }) => {
  const { banner, bannerMobile, bannerVideo, bannerVideoMobile, btn, content, contentMobile, list, listMobile, listContent, listContentMobile, listTitle, listTitleMobile, title, titleMobile  } = fields;
  const rootEl = useRef();
  const topEl = useRef();
  const bannerId = `banner-${rendering.uid}`
  const bodyId = `body-${rendering.uid}`
  const titleId = `title-${rendering.uid}`
  const contentId = `content-${rendering.uid}`
  const isMobile = mobileIs();
	let controller, tl;
	let listData = isMobile ? listMobile : list;
  let state = true;
	const bannerImage = isMobile ? bannerMobile : banner;
	const bannerVideoPlay = isMobile ? bannerVideoMobile : bannerVideo;
  useEffect(() => {
		let ScrollMagic, scene, scene2, scene3;
    tl = gsap.timeline({paused: true});
		tl.to(`#${titleId}`,{
      paddingTop: '60px'
		},'first')
		.to(`#${contentId}`,{
      paddingTop: '0'
		},'first')

		ScrollMagic = loadScrollMagic();
		controller = new ScrollMagic.Controller();

		scene = new ScrollMagic.Scene({
			triggerElement: rootEl.current,
			triggerHook: 0,

		})
		.setPin(`#${bannerId}`)
		.addTo(controller)
    scene.on("progress", function(event) {
      let ep = event.progress;
			if(ep > 0 && document.getElementById('videoPlay')){
				document.getElementById('videoPlay').play()
			}
		})

		scene2 = new ScrollMagic.Scene({
			triggerElement: `#${bodyId}`,
			triggerHook: 'onEnter',
      duration: window.innerHeight
		})
		.addTo(controller)
    scene2.on("progress", function(event) {
      let ep = event.progress;
			let es = event.scrollDirection;
			if(!document.getElementById(bannerId)) return false;
			if(ep == 1 ){
				document.getElementById(bannerId).style.display = 'none'
			}
			if(ep < 1){
				document.getElementById(bannerId).style.display = 'block'
			}
		})

		scene3 = new ScrollMagic.Scene({
			triggerElement: `#${titleId}`,
			triggerHook: 'onEnter',
      offset: 200,
      duration: window.innerHeight
		})
		.addTo(controller)
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      scene && scene.destroy(true);
      scene = null;
      scene2 && scene2.destroy(true);
      scene = null;
      scene3 && scene3.destroy(true);
      scene = null;
      controller && controller.destroy(true);
      controller = null;
    }
	},[])
  const handleScroll = () => {
    if (!topEl?.current) return;
    const rect = topEl?.current.getBoundingClientRect();
    const winHeight = window.innerHeight || document.documentElement.clientHeight;
    const inScreen = (rect.top >= 0 && rect.top <= winHeight - 200) || (rect.bottom >= 0 && rect.bottom <= winHeight - 200);
    let scrollDirection = controller.info("scrollDirection");
    if(!state && rect.top >= winHeight && scrollDirection === "REVERSE" && isMobile){
      tl && tl.revert();
      state = true;
    }
    if (state && inScreen && scrollDirection === "FORWARD" && isMobile) {
      tl && tl.restart();
      state = false;
    }
  };
  const downloadFile = (e, file) => {
  	gtag('event', 'Component_info', {
      'component_name': 'ImageOverlay',
      'page_title': page?.name
    });
  	let a = document.createElement('a')
  	a.setAttribute('target', '_blank')
    // a.setAttribute('download', 'download')
    a.setAttribute('href', file.value.src)
    document.body.appendChild(a)
    a.click()
  }
  return (
    <div className="image-overlay" datasourceid={rendering.dataSource} ref={rootEl}>

			{ !bannerVideoPlay.value &&
				<Image className="image-overlay-banner" id={bannerId} { ... bannerImage.value} />
			}
			{ bannerVideoPlay.value && 
				<div  className="image-overlay-banner" id={bannerId} >
					<video id="videoPlay" src={bannerVideoPlay?.value?.src} controls="false" loop muted></video>
				</div>
			
			}
			<div className="image-overlay-body" id={bodyId}>
				<div  className="image-overlay-top" ref={topEl} >
					<RichText className="image-overlay-title" id={titleId} field={isMobile ? titleMobile : title}/>
					<RichText className="image-overlay-content" id={contentId}  field={isMobile ? contentMobile : content} />
				</div>
				<div className={classNames("image-overlay-list", { "two": listData.length === 2 , "three": listData.length === 3 , "four": listData.length === 4 ,"five": listData.length === 5 })}>
					{listData.length > 0 && 
						listData.map((item, index) =>
						<ImageOverlayImage item={item} index={index} key={index}/>
						)
					}
					<div className={classNames("image-overlay-bottom", { "two": listData.length === 2 , "three": listData.length === 3 , "four": listData.length === 4 ,"five": listData.length === 5 })}>
						<RichText className="image-overlay-listTitle"  field={isMobile ? listTitleMobile : listTitle} />
						<RichText className="image-overlay-listContent"  field={isMobile ? listContentMobile : listContent} />
						{ btn?.fields &&
							<div onClick={(e) => downloadFile(e, btn?.fields?.file)}>
								<PrimaryButton {...{
									colorScheme: btn?.fields?.colorScheme,
									iconName: btn?.fields?.iconName,
									buttonText: btn?.fields?.btnText,
								}} />
							</div>
						}
					</div>
				</div>
			</div>
    </div>
  )
};
export default ImageOverlay;
